export enum CustomerForm {
	ApplicationMissingKyc = 'ApplicationMissingKyc',
	ApplicationPersonalInformationForm = 'ApplicationPersonalInformationForm',
	ApplicationAddressForm = 'ApplicationAddressForm',
	ApplicationFormerAddressForm = 'ApplicationFormerAddressForm',
	ApplicationAccommodationForm = 'ApplicationAccommodationForm',
	ApplicationEmploymentForm = 'ApplicationEmploymentForm',
	ApplicationExpensesForm = 'ApplicationExpensesForm',
	ApplicationContactInformationForm = 'ApplicationContactInformationForm',
	ApplicationLoanOfferForm = 'ApplicationLoanOfferForm',
	ApplicationBankInfoForm = 'ApplicationBankInfoForm',
	ApplicationUpdateForm = 'ApplicationUpdateForm',
	ApplicationCreditLimitForm = 'ApplicationCreditLimitForm',
	ApplicationFinancialForm = 'ApplicationFinancialForm',
	ApplicationNationalityForm = 'ApplicationNationalityForm',
	ApplicationMarketingPreferenceForm = 'ApplicationMarketingPreferenceForm',
	OtpStartForm = 'OtpStartForm',
	OtpCompleteForm = 'OtpCompleteForm',
	InvolveSpouseForm = 'InvolveSpouseForm',
	UpdateSpouseForm = 'UpdateSpouseForm',
}
